import React from 'react';
import classes from './ContactUs.module.scss';
import Txt from 'components/atoms/Txt/Txt';
import A from 'components/atoms/A/A';
import Button from 'components/atoms/Button/Button';
import Image from 'components/atoms/Image/Image';
import SplitRowCta from 'components/organisms/SplitRow/SplitRowCta';
import PageHeader from 'components/molecules/PageHeader/PageHeader';
import { FAQ, MORE } from 'components/pages/pages';
import contactimg1 from './assets/contact_img_1.png';
import contactimg2 from './assets/contact_img_2.png';
import SplitRow from 'components/organisms/SplitRow/SplitRow';
import FullWidthCta from 'components/organisms/FullWidthCta/FullWidthCta';
import RadioGroup from 'components/atoms/RadioButtons/RadioGroup';
import RadioButton from 'components/atoms/RadioButtons/RadioButton';
import Heading from 'components/atoms/Heading/Heading';

export interface Props {}

const ContactUs: React.FC<Props> = () => {
  const [isSecurityReport, setIsSecurityReport] = React.useState<boolean | null>(null);

  return (
    <main>
      <PageHeader title="Contact Qmee" backHref={MORE.path} />
      <SplitRow
        mobileColumnOrderSwapped
        contentAlignedTop
        isFirstRow
        leftColumn={
          <>
            <Heading level={1}>Contact Us</Heading>
            <Heading level={2}>FAQ&apos;s</Heading>
            <Txt component="p">
              For help with common problems, check out our <A href={FAQ.path}>FAQs</A> - the answer
              to your question may already be waiting for you there.
            </Txt>

            <SplitRowCta>
              <Button
                component={A}
                color="primary"
                buttonType="primary"
                buttonSize="large"
                href={FAQ.path}
                prefetch={false}
              >
                View Frequently Asked Questions
              </Button>
            </SplitRowCta>
          </>
        }
        rightColumn={<Image src={contactimg1} alt="Contact Us" />}
      />

      <SplitRow
        hasBorderBottom
        contentAlignedTop
        leftColumn={
          <>
            <section>
              <Heading level={2}>Customer Support</Heading>

              <Txt component="p">
                If you have a query about your account, or something isn&apos;t working as it should
                be, send our friendly support team an email at:
              </Txt>

              <Txt component="p">
                <a className={classes.contactLink} href="mailto:support@qmee.com">
                  support@qmee.com
                </a>
              </Txt>

              <Txt component="p">
                To ensure our experienced support agents can help you as quickly as possible,{' '}
                <strong>please email from the email address listed on your Qmee account</strong>. If
                you haven&apos;t signed up to Qmee yet, not to worry - you can still get in touch
                with our friendly support team.
              </Txt>
            </section>
          </>
        }
        rightColumn={
          <>
            <section>
              <Heading level={2}>Survey Queries</Heading>

              <Txt component="p">
                If your query is related to a survey, please ensure you include the Survey ID Number
                in your email - this can be found in the &apos;Recently Finished Surveys&apos;
                section of your dashboard.
              </Txt>

              <Txt component="p">
                <strong>Don&apos;t have a Qmee account but have a question?</strong> You can also
                can also email{' '}
                <a className={classes.contactLink} href="mailto:support@qmee.com">
                  support@qmee.com
                </a>{' '}
                get in touch.
              </Txt>
            </section>
          </>
        }
      />

      <SplitRow
        contentAlignedTop
        leftColumn={
          <>
            <Txt component="h2">Security Support</Txt>
            <Txt component="p">
              Are you a security researcher or have you found a vulnerability that you would like to
              report?
            </Txt>
            <RadioGroup>
              <RadioButton
                value="yes"
                name="securityReport"
                label="Yes"
                onClick={() => setIsSecurityReport(true)}
              />
              <RadioButton
                value="radio2"
                name="securityReport"
                label="No"
                onClick={() => setIsSecurityReport(false)}
              />
            </RadioGroup>
            {isSecurityReport === true && (
              <>
                <Txt component="p">
                  Please contact our <strong>Security Support Team</strong> via{' '}
                  <a href="mailto:security@qmee.com">security@qmee.com</a>.
                </Txt>
                <Txt component="p">
                  If necessary, use our <a href="/security.asc">public key</a> to keep your message
                  safe and please provide us with a secure way to respond.
                </Txt>
                <Txt component="p">
                  We&apos;ll get back to you as soon as we can, usually within 24 hours to tell you
                  the best way to track the status of your issue.
                </Txt>
              </>
            )}
            {isSecurityReport === false && (
              <>
                <Txt component="p">
                  Please contact our <strong>Customer Support Team</strong> via{' '}
                  <a className={classes.contactLink} href="mailto:support@qmee.com">
                    support@qmee.com
                  </a>
                  .
                </Txt>
                <Txt component="p">
                  To ensure our experienced support agents can help you as quickly as possible,{' '}
                  <strong>please email from the email address listed on your Qmee account</strong>.
                  If you haven&apos;t signed up to Qmee yet, not to worry - you can still get in
                  touch with our friendly support team.
                </Txt>
              </>
            )}
          </>
        }
        rightColumn={<Image src={contactimg2} alt="Have a query about security?" />}
      />

      <FullWidthCta
        title={<Txt>Frequently Asked Questions</Txt>}
        ctaText="FAQ's"
        ctaLink={FAQ.path}
      >
        Check out our FAQ&apos;s to help with any unanswered questions
      </FullWidthCta>
    </main>
  );
};

export default ContactUs;
